<template>
          <div class="box">
        <div class="contaner-title"><span>财务管理</span> <span>/ 资金明细</span></div>
        <div class="hr"></div>
        <Row >
            <Col span="3">
                <Date-picker type="date" v-model="startDate" placeholder="开始日期" style="width: 200px"></Date-picker>
            </Col>
            <Col span="3">
                <Date-picker type="date" v-model="endDate" placeholder="结束日期" style="width: 200px"></Date-picker>
            </Col>
            <!-- <Col span="3">
             <Select v-model="Status" placeholder="审批状态" >
                 <img src="../../assets/status.png"  slot="prefix"  alt="">
                 <Option :value="4">全部</Option>
                 <Option :value="0">收入</Option>
                 <Option :value="1">支出</Option>
            </Select>
            </Col> -->
            <Col span="1">
            <Button type="primary" ><icon size="20"  type="ios-search" @click.native="searchData" /></Button>
            </Col>
        </Row>
        <div v-if="UserType == 2 || UserType == 3" class="tab">
            <Tabs>
                <TabPane label="已结算" class="tab">
                    <Table  :row-class-name="rowClassName" :columns="columns" :data="remitSettledList"></Table>
                    <div v-if="remitSettledList.length > 0" style="text-align:right;padding:30px 0px;">
                        <Page :total="CountSettled" :page-size="PageSize" @on-change="changePageSettled" />
                    </div>
                </TabPane>
                <TabPane label="未结算" class="tab">
                    <Table  :row-class-name="rowClassName" :columns="columns" :data="remitUnSettledList"></Table>
                    <div v-if="remitUnSettledList.length > 0" style="text-align:right;padding:30px 0px;">
                        <Page :total="CountUnSettled" :page-size="PageSize" @on-change="changePageUnSettled" />
                    </div>
                </TabPane>
                <TabPane label="冻结" class="tab">
                    <Table  :row-class-name="rowClassName" :columns="columns" :data="remitFrozenList"></Table>
                    <div v-if="remitFrozenList.length > 0" style="text-align:right;padding:30px 0px;">
                        <Page :total="CountFrozen" :page-size="PageSize" @on-change="changePageFrozen" />
                    </div>
                </TabPane>
                <TabPane label="预计" class="tab">
                    <Table  :row-class-name="rowClassName" :columns="columns" :data="remitEstimateList"></Table>
                    <div v-if="remitEstimateList.length > 0" style="text-align:right;padding:30px 0px;">
                        <Page :total="CountEstimate" :page-size="PageSize" @on-change="changePageEstimate" />
                    </div>
                </TabPane>
            </Tabs>
        </div>
        <div v-if="UserType == 1" class="tab">
            <Table  :row-class-name="rowClassName" :columns="columns" :data="remitList"></Table>
            <div v-if="remitList.length > 0" style="text-align:right;padding:30px 0px;">
                <Page :total="Count" :page-size="PageSize" @on-change="changePage" />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
                UserType: '',
                UserInfo: [],
                PageSize:10,//每页显示数量
                //资金明细列表
                remitList: [],
                Count: 0,
                Page: 1,
                //已结算
                remitSettledList: [],
                CountSettled: 0,
                PageSettled: 1,
                //未结算
                remitUnSettledList: [],
                CountUnSettled: 0,
                PageUnSettled: 1,
                //冻结
                remitFrozenList: [],
                CountFrozen: 0,
                PageFrozen: 1,
                //预计
                remitEstimateList: [],
                CountEstimate: 0,
                PageEstimate: 1,
                // keyword:'',
                startDate: '',
                endDate: '',
                // Status: 4,
                columns: [
                    {
                        title: '日期',
                        key: 'AddTime',
                        align:'center',
                        render:(h,params)=>{
                            var text='';
                            if(params.row.AddTime){
                                text= new Date(params.row.AddTime).format("yyyy-MM-dd hh:mm:ss");
                            }
                            return h('span',{

                             },text)
                        }
                    },
                     {
                        title: '收入',
                        key: 'Earn',
                         align:'center',
                         render:(h,params)=>{
                             var text = "-";
                             if (params.row.Earn != '') {
                                 text = params.row.Earn;
                             }
                             return h('span',{
                                 style:{
                                     color:params.row.Earn == '' ? '#000' : '#00b22d'
                                 }
                             },text)
                         }
                    },
                    {
                        title: '支出',
                        key: 'Pay',
                         align:'center',
                         render:(h,params)=>{
                             var text = "-";
                             if (params.row.Pay != '') {
                                 text = params.row.Pay;
                             }
                             return h('span',{
                                 style:{
                                     color:params.row.Pay == '' ? '#000' : '#ff7f00'
                                 }

                             },text)
                         }
                    },
                    //  {
                    //     title: '账户余额',
                    //     key: 'Fee',
                    //      align:'center',
                    // },
                    {
                        title: '备注',
                        key: 'Remark',
                        align:'center',
                    },
                ],
        }
    },
    mounted(){
        Date.prototype.format = function(fmt) { 
            var o = { 
                "M+" : this.getMonth()+1,                 //月份 
                "d+" : this.getDate(),                    //日 
                "h+" : this.getHours(),                   //小时 
                "m+" : this.getMinutes(),                 //分 
                "s+" : this.getSeconds(),                 //秒 
                "q+" : Math.floor((this.getMonth()+3)/3), //季度 
                "S"  : this.getMilliseconds()             //毫秒 
            }; 
            if(/(y+)/.test(fmt)) {
                fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length)); 
            }
            for(var k in o) {
                if(new RegExp("("+ k +")").test(fmt)){
                    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
                }
            }
            return fmt; 
        }
        let UserInfo = JSON.parse(this.$getLS('AdminInfo'));
        this.UserType = UserInfo.Type;
        this.UserInfo = UserInfo;
        if (this.UserType == 1) {
            this.getUserData();
        } else {
            this.getSettledData();
            this.getUnSettledData();
            this.getFrozenData();
            this.getEstimateData();
        }
    },
    methods:{
        searchData(){
            if (this.UserType == 1) {
                this.Page = 1;
                this.getUserData();
            } else {
                this.PageSettled=1;
                this.PageUnsettled=1;
                this.PageFrozen=1;
                this.PageEstimate=1;
                this.getSettledData();
                this.getUnSettledData();
                this.getFrozenData();
                this.getEstimateData();
            }
        },
        changePage(val){
            this.Page=val;
            this.getUserData();
        },
        changePageSettled(val){
            this.PageSettled=val;
            this.getSettledData();
        },
        changePageUnSettled(val){
            this.PageUnSettled=val;
            this.getUnSettledData();
        },
        changePageFrozen(val){
            this.PageFrozen=val;
            this.getFrozenData();
        },
        changePageEstimate(val){
            this.PageEstimate=val;
            this.getEstimateData();
        },
        getUserData(){
            var params={
                page: this.Page,
                pageSize: this.PageSize,
                // keyword:this.keyword,
                startDate:this.startDate,
                endDate:this.endDate,
                UserID:this.UserInfo.ID,
            }
            this.$post('api/manage.RemitManage/userRemitList',params).then(res=>{
                if(res.code==1){
                    this.remitList = res.data.data;
                    this.Count = res.data.all_num;
                }
            })
        },
        getSettledData(){
            var params={
                page: this.PageSettled,
                pageSize: this.PageSize,
                // keyword:this.keyword,
                startDate:this.startDate,
                endDate:this.endDate,
            }
            this.$post('api/manage.RemitManage/remitSettledList',params).then(res=>{
                if(res.code==1){
                    this.remitSettledList = res.data.data;
                    this.CountSettled = res.data.all_num;
                }
            })
        },
        getUnSettledData(){
            var params={
                page: this.PageUnSettled,
                pageSize: this.PageSize,
                // keyword:this.keyword,
                startDate:this.startDate,
                endDate:this.endDate,
            }
            this.$post('api/manage.RemitManage/remitUnSettledList',params).then(res=>{
                if(res.code==1){
                    this.remitUnSettledList = res.data.data;
                    this.CountUnSettled = res.data.all_num;
                }
            })
        },
        getFrozenData(){
            var params={
                page: this.PageFrozen,
                pageSize: this.PageSize,
                // keyword:this.keyword,
                startDate:this.startDate,
                endDate:this.endDate,
            }
            this.$post('api/manage.RemitManage/remitFrozenList',params).then(res=>{
                if(res.code==1){
                    this.remitFrozenList = res.data.data;
                    this.CountFrozen = res.data.all_num;
                }
            })
        },
        getEstimateData(){
            var params={
                page: this.PageEstimate,
                pageSize: this.PageSize,
                // keyword:this.keyword,
                startDate:this.startDate,
                endDate:this.endDate,
            }
            this.$post('api/manage.RemitManage/remitEstimateList',params).then(res=>{
                if(res.code==1){
                    this.remitEstimateList = res.data.data;
                    this.CountEstimate = res.data.all_num;
                }
            })
        },
        rowClassName (row, index) {
            if ((index%2) === 1) {
                return 'demo-table-info-row';
            } 
            return '';
        }
    }
}
</script>
<style lang="less" scoped>
.box{
    padding:30px;
    box-sizing: border-box;
    height: 100%;
    >.ivu-row{
        margin-top: 20px;
        background-color: #fff;
        padding:20px 10px;
        box-shadow: 0px 3px 5px #D9DDE3;
        >.ivu-col{
            margin-right: 10px;
        }
    }
    .tab{
        height: calc(~"100% - 129px");
        margin-top: 20px;
        background-color: #fff;
        padding: 10px;
        box-shadow: 0px 3px 5px #D9DDE3;
    }
}
.table-c{
 table{
     border-right:1px solid #CAF2FF;border-bottom:1px solid #CAF2FF;
  td{
border-left:1px solid #CAF2FF;
padding:10px;
  text-align: center;
  border-top:1px solid #CAF2FF;
  font-size:12px;}
  .label{
      background-color: #F0FCFF;
      color: #0092C1;
  }
 } 
}
 .header-modal{
        padding:10px 15px;
        color: #fff;
        background-color: #01AAE3;
        font-size: 22px;
        display: flex;
        position: relative;
        span{
            margin-left: 20px;
            margin-top: 3px;
        }
        .close{
            width: 22px;
            height: 22px;
            position: absolute;
            right:14px;
            cursor: pointer;
            top:14px;
        }
    }
.content-modal{
    padding:20px;

}
.input-text{
    width: 100%;
    border-radius: 5px;
    border: 1px solid #eee;
    height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/view/AccountManage/CapitalDetail.vue